// src/_redux/reducers/AuthSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  user: null,
  isAuthenticated: false,
  notifications: [],
  notification: null,
  loading: false, // For managing loading state
  error: null,    // For managing errors
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    signInSuccess(state, action) {
      state.user = action.payload;
      state.isAuthenticated = true;
    },
    signOutSuccess(state) {
      state.user = null;
      state.isAuthenticated = false;
    },
    setUser(state, action) {
      state.user = action.payload;
      state.isAuthenticated = !!action.payload;
    },
    fetchNotificationsStart(state) {
      state.loading = true;
      state.error = null; // Clear any previous error
    },
    fetchNotificationsSuccess(state, action) {
      state.notifications = action.payload;
      state.loading = false;
    },
    fetchNotificationsFailure(state, action) {
      state.loading = false;
      state.error = action.payload; // Save the error message
    },
  },
});

export const selectUser = (state) => state.auth.user;
export const isAuthenticated = (state) => state.auth.user !== null;

// Export the actions
export const {
  signInSuccess,
  signOutSuccess,
  setUser,
  fetchNotificationsStart,
  fetchNotificationsSuccess,
  fetchNotificationsFailure,
} = authSlice.actions;

export default authSlice.reducer;
